module.exports = __webpack_public_path__ + "static/media/obc-hybrid.46f1b348.svg";